import { useState, useEffect } from 'react';
import Button from '../base/Button';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/f93d48f1419f4c68f20bbda738a4241b/9e91394b746ace23109b617e18e35438.png" 
              alt="Terra Construction Logo" 
              className="h-16 w-auto"
              style={{ backgroundColor: 'transparent' }}
            />
            <div className="text-2xl font-bold text-[#1C1C1C] font-['Playfair_Display']">
              Terra Construction
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-[#1C1C1C] hover:text-[#4B6043] transition-colors cursor-pointer"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-[#1C1C1C] hover:text-[#4B6043] transition-colors cursor-pointer"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-[#1C1C1C] hover:text-[#4B6043] transition-colors cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('portfolio')}
              className="text-[#1C1C1C] hover:text-[#4B6043] transition-colors cursor-pointer"
            >
              Portfolio
            </button>
            <button 
              onClick={() => scrollToSection('reviews')}
              className="text-[#1C1C1C] hover:text-[#4B6043] transition-colors cursor-pointer"
            >
              Reviews
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-[#1C1C1C] hover:text-[#4B6043] transition-colors cursor-pointer"
            >
              Contact
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              size="sm"
            >
              Get Quote
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-[#1C1C1C] hover:text-[#4B6043] cursor-pointer"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-md border-t">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button 
                onClick={() => scrollToSection('home')}
                className="block px-3 py-2 text-[#1C1C1C] hover:text-[#4B6043] cursor-pointer"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="block px-3 py-2 text-[#1C1C1C] hover:text-[#4B6043] cursor-pointer"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="block px-3 py-2 text-[#1C1C1C] hover:text-[#4B6043] cursor-pointer"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('portfolio')}
                className="block px-3 py-2 text-[#1C1C1C] hover:text-[#4B6043] cursor-pointer"
              >
                Portfolio
              </button>
              <button 
                onClick={() => scrollToSection('reviews')}
                className="block px-3 py-2 text-[#1C1C0C] hover:text-[#4B6043] cursor-pointer"
              >
                Reviews
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="block px-3 py-2 text-[#1C1C1C] hover:text-[#4B6043] cursor-pointer"
              >
                Contact
              </button>
              <div className="px-3 py-2">
                <Button 
                  onClick={() => scrollToSection('contact')}
                  size="sm"
                  className="w-full"
                >
                  Get Quote
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
